export default __webpack_public_path__ + "static/media/JoeySchultz.17c7dbe4.jpg";